export default __webpack_public_path__ + "static/media/money-back@3x.f226e384.png";